// Single source of truth for "routes a signed-out visitor is meant to load."
//
// A 401 from a background API call on one of these pages (marketing, legal,
// signup, public event/ticket pages, OAuth popups) must NEVER hard-redirect
// the visitor to /login — that turns the public site into an auth wall and
// is exactly the "/about and /download bounce to the login screen" report.
//
// Consumed by both axios 401 interceptors (src/api/axiosBoot.js and
// src/api/client.js) and the fetch wrapper. Matched as prefixes against
// window.location.pathname.

export const PUBLIC_PATH_PREFIXES = [
  '/about',            // /about (Download landing) + /about-me
  '/download',         // legacy alias, redirects to /about
  '/login',
  '/logout',
  '/owneradd',
  '/ownerlogin',
  '/tenantadd',
  '/termsofuse',
  '/privacypolicy',
  '/sendemail',
  '/reset-password',
  '/external-upload/',
  '/e/',               // public event landing pages
  '/tickets/',         // public ticket-order pages
];

export function isPublicPath(pathname) {
  const p = pathname || (typeof window !== 'undefined' ? window.location.pathname : '/') || '/';
  if (p === '/') return true;
  return PUBLIC_PATH_PREFIXES.some((prefix) => p === prefix || p.startsWith(prefix));
}
